import React from 'react';

const AboutModal = ({ isOpen, modalType, closeModal }) => {
  if (!isOpen) return null;

  const storyContent = `Hygea Wellness Spa is inspired by Hygeia, the Greek goddess of good health and the daughter of the god of medicine, Asclepius. Our spa is dedicated to promoting relaxation, healing, and overall wellness for the mind, body, and spirit. We offer a full-service massage spa experience that focuses on providing excellent service, quality products, and a calm, enjoyable atmosphere for our clients. Our trained staff ensures a friendly, fair, and creative environment while respecting diversity and hard work. At Hygea Wellness Spa, we offer a variety of services including Stone Massage, Swedish Massage, Thai Massage, and Dry Massage, each designed to improve circulation, relieve tension, and restore balance to the body. To complement our massage services, we also provide beauty treatments such as facial care, nail care (manicure and pedicure), and waxing, helping our clients look and feel their best. Our goal is to provide high-quality wellness services at affordable prices while building strong and lasting relationships with our customers.`;

  const missionContent = `Our mission is to consistently deliver top-quality massage and wellness services with dedication, professionalism, and care, ensuring every client leaves feeling refreshed and valued.`;

  const visionContent = `To become the Philippines' premier service provider for massage spa with precise skill and attention to detail, bringing out one's natural beauty and wellness. Our goal is to create a serene, holistic, and rejuvenating experience for every client.`;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-[92vw] max-w-2xl max-h-[85vh] p-8 relative animate-fadeIn flex flex-col">
        
        {/* Close Button */}
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
        >
          &times;
        </button>

        {/* Modal Title */}
        <h3 className="text-3xl font-bold text-green-900 mb-4 border-b-2 border-green-200 pb-2">
          {modalType === "story" && "Our Story"}
          {modalType === "mission" && "Our Mission"}
          {modalType === "vision" && "Our Vision"}
        </h3>

        {/* Modal Content */}
        <p className="text-gray-700 text-base md:text-lg leading-relaxed max-h-[60vh] overflow-y-auto pr-1">
          {modalType === "story" && storyContent}
          {modalType === "mission" && missionContent}
          {modalType === "vision" && visionContent}
        </p>

        {/* Decorative Separator */}
        <div className="mt-6 h-1 w-20 bg-gradient-to-r from-green-200 to-green-400 rounded-full mx-auto"></div>
      </div>
    </div>
  );
};

export default AboutModal;